import { render, staticRenderFns } from "./SearchCompanyName.vue?vue&type=template&id=27bb6e03&scoped=true"
import script from "./SearchCompanyName.vue?vue&type=script&lang=js"
export * from "./SearchCompanyName.vue?vue&type=script&lang=js"
import style0 from "./SearchCompanyName.vue?vue&type=style&index=0&id=27bb6e03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb6e03",
  null
  
)

export default component.exports